// extracted by css-extract-rspack-plugin
export default {"confirmation":"GfmInterestConfirmationModal_confirmation__W8rGX","confirmationDefault":"GfmInterestConfirmationModal_confirmationDefault__a9kSY"};